module.exports = __webpack_public_path__ + "static/img/logo-icon.797bf8d9.png";